module.exports = __webpack_public_path__ + "static/media/Contempt.7fed9b68.png";